module.exports = __webpack_public_path__ + "static/media/scarecrow.6ec857bb.svg";